import { Component } from '@angular/core';

import { MenuContentItem, MenuDisplayMode } from '@frontend/vanilla/core';
import { MenuItemComponent } from '@frontend/vanilla/features/menus';

import { AccountMenuItemBase } from '../account-menu-item-base';

@Component({
    imports: [MenuItemComponent],
    selector: 'vn-am-side-menu-item',
    templateUrl: 'side-menu-item.html',
})
export class SideMenuItemComponent extends AccountMenuItemBase {
    constructor() {
        super();
    }

    click(event: Event, item: MenuContentItem): void {
        if (!this.item.parameters['disableClick']) {
            this.processClick(event, item, false);
        }
    }

    protected readonly MenuDisplayMode = MenuDisplayMode;
}
